var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": "right",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Category3",
                                        prop: "category3Code",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.queryCondition.category3Code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "category3Code",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.category3Code",
                                          },
                                        },
                                        _vm._l(
                                          _vm.category3CodeOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.object,
                                                value: item.key,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Sponsor",
                                        prop: "sponsorName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.sponsorName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "sponsorName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.sponsorName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Farm Group",
                                        prop: "farmGroup",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.farmGroup,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "farmGroup",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.farmGroup",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "农场名称",
                                        prop: "farmName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.farmName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "farmName",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.farmName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "农场状态",
                                                prop: "farmStatus",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .farmStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "farmStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.farmStatus",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.farmStatusOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.object,
                                                        value: item.key,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "审批状态",
                                                prop: "auditStatus",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .auditStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "auditStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.auditStatus",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.auditStatusOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.object,
                                                        value: item.key,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_ADD,
                          expression: "RMC_PROD_FARM_ADD",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onAdd },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_DELETE,
                          expression: "RMC_PROD_FARM_DELETE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "danger" },
                      on: { click: _vm.onDel },
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_SUBMIT,
                          expression: "RMC_PROD_FARM_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_AUDIT,
                          expression: "RMC_PROD_FARM_AUDIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onVerificationAudit },
                    },
                    [_vm._v("验证审核维护")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_APPROVE,
                          expression: "RMC_PROD_FARM_APPROVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onApprove },
                    },
                    [_vm._v("批准")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_RETURN,
                          expression: "RMC_PROD_FARM_RETURN",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onReturn },
                    },
                    [_vm._v("退回")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_CONFIRM,
                          expression: "RMC_PROD_FARM_CONFIRM",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.confirmIsUpdate },
                    },
                    [_vm._v("确认无更新")]
                  )
                : _vm._e(),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value:
                        (_vm.RMC_PROD_FARM_REPORT,
                        _vm.RMC_PROD_FARM_REPORT_QUR),
                      expression:
                        "RMC_PROD_FARM_REPORT,RMC_PROD_FARM_REPORT_QUR",
                    },
                  ],
                  attrs: {
                    "split-button": "",
                    type: "primary",
                    placement: "bottom",
                  },
                },
                [
                  _vm._v(" 报表导出 "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.RMC_PROD_FARM_REPORT,
                                  expression: "RMC_PROD_FARM_REPORT",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.downloadFarm },
                            },
                            [_vm._v("农场清单")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.RMC_PROD_FARM_REPORT_QUR,
                                  expression: "RMC_PROD_FARM_REPORT_QUR",
                                },
                              ],
                              staticClass: "dropdownItemBtn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.downloadFarmQuarter },
                            },
                            [_vm._v("农场清单季度")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value:
                            (_vm.RMC_PROD_FARM_IMPORT_AUDIT,
                            _vm.RMC_PROD_FARM_IMPORT),
                          expression:
                            "RMC_PROD_FARM_IMPORT_AUDIT,RMC_PROD_FARM_IMPORT",
                        },
                      ],
                      attrs: {
                        "split-button": "",
                        type: "primary",
                        placement: "bottom",
                      },
                    },
                    [
                      _vm._v(" 批量导入 "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _vm.ms_roles.indexOf(
                            "QSPI_RMC_PRODUCE_SPONS_SUPP"
                          ) !== -1
                            ? _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.RMC_PROD_FARM_IMPORT,
                                      expression: "RMC_PROD_FARM_IMPORT",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: { click: _vm.onBatchUpload },
                                    },
                                    [_vm._v("农场清单")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.ms_roles.indexOf(
                            "QSPI_RMC_PRODUCE_SPONS_SUPP"
                          ) !== -1
                            ? _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.RMC_PROD_FARM_IMPORT_AUDIT,
                                      expression: "RMC_PROD_FARM_IMPORT_AUDIT",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "dropdownItemBtn",
                                      attrs: { size: "mini", type: "primary" },
                                      on: { click: _vm.onBatchUploadVertify },
                                    },
                                    [_vm._v("验证审核时间/结果")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.ms_roles.indexOf(
                            "QSPI_RMC_PRODUCE_SPONS_SUPP"
                          ) !== -1
                            ? _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.RMC_PROD_FARM_IMPORT_AUDIT,
                                      expression: "RMC_PROD_FARM_IMPORT_AUDIT",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload2",
                                      attrs: {
                                        headers: _vm.header,
                                        action: _vm.uploadUrl2,
                                        "on-success": _vm.uploadSuccess2,
                                        "on-error": _vm.uploadError,
                                        "before-upload": _vm.beforeUpload2,
                                        "file-list": _vm.fileList2,
                                        limit: 1,
                                        "auto-upload": true,
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "dropdownItemBtn",
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                        },
                                        [_vm._v("验证审核报告附件")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_CHANGE_LOG,
                          expression: "RMC_PROD_FARM_CHANGE_LOG",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onUpdateLog },
                    },
                    [_vm._v("更新日志")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_AUDIT_DOWNLOAD,
                          expression: "RMC_PROD_FARM_AUDIT_DOWNLOAD",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.downloadAuditReport },
                    },
                    [_vm._v("审核报告下载")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              attrs: {
                data: _vm.tableData,
                "max-height": "600",
                "show-overflow": "tooltip",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  type: "checkbox",
                  width: "80",
                  fixed: "left",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Category3",
                  resizable: "",
                  "min-width": "100",
                  field: "category3Name",
                  fixed: "left",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Sponsor",
                  resizable: "",
                  "min-width": "90",
                  field: "sponsorName",
                  fixed: "left",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Farm Group",
                  resizable: "",
                  "min-width": "120",
                  field: "farmGroup",
                  fixed: "left",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "品类",
                  resizable: "",
                  "min-width": "100",
                  field: "varietiesView",
                  fixed: "left",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "农场名称",
                  resizable: "",
                  "min-width": "90",
                  field: "farmName",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDetail(row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.farmName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "农场地址",
                  resizable: "",
                  "min-width": "90",
                  field: "farmAddress",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "农场规模(亩)",
                  resizable: "",
                  "min-width": "120",
                  field: "plantingScale",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "作物",
                  resizable: "",
                  "min-width": "120",
                  field: "cropView",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "种植模式",
                  resizable: "",
                  "min-width": "120",
                  field: "plantingModeView",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "定植期",
                  resizable: "",
                  "min-width": "120",
                  field: "plantingPeriod",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "采收期",
                  resizable: "",
                  "min-width": "90",
                  field: "harvestTime",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "联系人",
                  resizable: "",
                  "min-width": "90",
                  field: "farmContacts",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "联系方式",
                  resizable: "",
                  "min-width": "90",
                  field: "contactInformation",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "其他",
                  resizable: "",
                  "min-width": "90",
                  field: "comments",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "农场状态",
                  resizable: "",
                  "min-width": "90",
                  field: "farmStatusView",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "修改原因",
                  resizable: "",
                  "min-width": "90",
                  field: "updateReason",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "审批状态",
                  resizable: "",
                  "min-width": "90",
                  field: "auditStatusView",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "提交人",
                  resizable: "",
                  "min-width": "90",
                  field: "submitName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "提交时间",
                  resizable: "",
                  "min-width": "90",
                  field: "submitDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "审批通过日期",
                  resizable: "",
                  "min-width": "120",
                  field: "approvedDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "2方验证审核时间",
                  resizable: "",
                  "min-width": "120",
                  field: "secondPartyAuditDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "2方验证审核结果",
                  resizable: "",
                  "min-width": "120",
                  field: "secondPartyAuditResult",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "2方验证审核报告",
                  resizable: "",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "right",
                              width: "500",
                              trigger: "click",
                            },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: scope.row.secondPartyAuditReportList,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "index", label: "序号" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": "",
                                    property: "documentName",
                                    label: "文件名称",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDownload1(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.documentName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { slot: "reference", type: "text" },
                                slot: "reference",
                              },
                              [_vm._v("查看")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "3方验证审核时间",
                  resizable: "",
                  "min-width": "120",
                  field: "thirdPartyAuditDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "MGG审核结果",
                  resizable: "",
                  "min-width": "120",
                  field: "mggAuditResult",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "GGAP审核结果",
                  resizable: "",
                  "min-width": "120",
                  field: "ggapAuditResult",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "GNN",
                  resizable: "",
                  "min-width": "120",
                  field: "gnn",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "3方验证审核报告",
                  resizable: "",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "right",
                              width: "500",
                              trigger: "click",
                            },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: scope.row.thirdPartyAuditReportList,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "index", label: "序号" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": "",
                                    property: "documentName",
                                    label: "文件名称",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDownload2(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.documentName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { slot: "reference", type: "text" },
                                slot: "reference",
                              },
                              [_vm._v("查看")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                  "page-count": _vm.pages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogUpdateVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "更新状态",
                visible: _vm.dialogUpdateVisible,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogUpdateVisible = $event
                },
                close: _vm.onClose,
              },
            },
            [_c("update-Dialog", { on: { onClose: _vm.onClose } })],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "退回意见",
            visible: _vm.dialogReturnVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReturnVisible = $event
            },
            close: _vm.onCancelReturn,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "returnForm",
              attrs: { model: _vm.returnForm, rules: _vm.returnFormRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "returnedReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "1000",
                      "show-word-limit": "",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.returnForm.returnedReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnForm, "returnedReason", $$v)
                      },
                      expression: "returnForm.returnedReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onCancelReturn } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择季度",
            visible: _vm.dialogQuarterVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogQuarterVisible = $event
            },
            close: _vm.onCancelQuarter,
          },
        },
        [
          _c("quarterDialog", {
            ref: "quarterDialog",
            attrs: { type: _vm.type },
            on: { onCancelQuarter: _vm.onCancelQuarter },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入",
            visible: _vm.dialogBatchUploadVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBatchUploadVisible = $event
            },
            close: _vm.onCloseUpload,
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-upload",
                {
                  ref: "batchUpload",
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "10px",
                  },
                  attrs: {
                    headers: _vm.header,
                    action: _vm.uploadListsUrl,
                    "on-success": _vm.uploadListsSuccess,
                    "on-error": _vm.uploadError,
                    "on-change": _vm.handleChange,
                    "before-upload": _vm.beforeListsUpload,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    "show-file-list": false,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("选取文件")]
                  ),
                ],
                1
              ),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "button",
                    target: "_blank",
                    href: _vm.href,
                    download: _vm.downloadUrl,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      staticStyle: { height: "100%" },
                      attrs: { type: "primary", size: "small" },
                    },
                    [_vm._v("导入模板下载")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.uploadForm.fileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "fileName", $$v)
                      },
                      expression: "uploadForm.fileName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", [
            _c("h4", [_vm._v("说明:")]),
            _c("ul", [
              _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
              _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
              _c("li", [_vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M")]),
              _c("li", [
                _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
              ]),
              _c("li", [
                _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
              ]),
            ]),
          ]),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onUpload },
                },
                [_vm._v("上传")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onClose1 },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }